export const getProductAttributeValue = (attributeCode, product, groupName) => {
  let value = "-";

  const group = product.info.groups.find((group) => group.name === groupName);

  if (group) {
    const attribute = group.attributes.find(
      (at) => at.attribute_code === attributeCode
    );

    if (attribute) {
      value = attribute.value;
    }
  }

  return value;
};
